import { Col, Row, Button } from "react-bootstrap";
import BackArrow from "../../backArrow";
import Form from "react-bootstrap/Form";
import { useLocation } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import PersonalImage from "../../../helpers/fileUpload";
import Card from "react-bootstrap/Card";
import { images } from "../../../constants";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ClearIcon from "@mui/icons-material/Clear";
import { currencies } from "../../../constants/jsonConstant";
import { getAsset } from "../../../helpers/helper";
import { Formik } from "formik";
import * as Yup from "yup";
import { useGetWorldCitiesQuery } from "../../../features/shop/shopApiSlice";
import "./propertyAdform.css";

const PropertyAdForm = ({
  butn,
  id,
  back,
  setPropertyadd,
  propertyadd,
  title,
  Updatehandler,
  handlerFunction,
  index,
  itemid,
  shopCategorytwo,
  shopCategory,
  Handledata,
  Mydata,
  Firstcategory,
  link,
  getInputProps,
  getRootProps,
  displayimg,
  setDisplayimg,
   isUploading,    
  uploadProgress,
}) => {
  const [selectedImage, setSelectedImage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const inputfile = useRef(null);
  const upload_img = () => {
    inputfile.current.click();
  };

  // Refs for input fields
  const priceRef = useRef(null);
  const areaRef = useRef(null);
  const emailRef = useRef(null);
  const descriptionRef = useRef(null);

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  const [selectedCountry, setSelectedCountry] = useState(
    propertyadd?.country || "",
  );
  const [selectedstateone, setSelectedstateone] = useState(
    propertyadd?.state || "",
  );
  const [selectedcity, setSelectedcity] = useState(propertyadd?.city || "");

  const { data: worldCitiesData } = useGetWorldCitiesQuery();
  const countrydata = worldCitiesData || [];
  const [getState, setState] = useState([]);
  const [getcity, setGetcity] = useState([]);

  const handleValue = (event) => {
    setPropertyadd((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  useEffect(() => {
    // Clear input fields on mount to prevent autofill
    if (priceRef.current) priceRef.current.value = propertyadd?.price || "";
    if (areaRef.current) areaRef.current.value = propertyadd?.area || "";
    if (emailRef.current) emailRef.current.value = propertyadd?.email || "";
    if (descriptionRef.current)
      descriptionRef.current.value = propertyadd?.description || "";
  }, [propertyadd]);

  const country = [
    ...new Set(countrydata.map((item) => item.country)),
  ].filter(Boolean);
  country.sort();

  // Sync location from backend API propertyadd
  useEffect(() => {
    const targetCountry = propertyadd?.country || "";
    const targetState = propertyadd?.state || "";
    const targetCity = propertyadd?.city || "";

    if (targetCountry && targetCountry !== selectedCountry) {
      setSelectedCountry(targetCountry);
    }
    if (targetState && targetState !== selectedstateone) {
      setSelectedstateone(targetState);
    }
    if (targetCity && targetCity !== selectedcity) {
      setSelectedcity(targetCity);
    }
  }, [propertyadd?.country, propertyadd?.state, propertyadd?.city]);

  // Synchronize state options whenever selectedCountry or countrydata changes
  useEffect(() => {
    if (selectedCountry && countrydata.length > 0) {
      let states = countrydata.filter(
        (item) => item.country === selectedCountry,
      );
      states = [...new Set(states.map((item) => item.subcountry))].filter(
        Boolean,
      );
      states.sort();
      setState(states);
    } else if (!selectedCountry) {
      setState([]);
    }
  }, [selectedCountry, countrydata]);

  // Synchronize city options whenever selectedstateone or countrydata changes
  useEffect(() => {
    if (selectedstateone && countrydata.length > 0) {
      let cities = countrydata.filter(
        (item) => item.subcountry === selectedstateone,
      );
      setGetcity(cities);
    } else if (!selectedstateone) {
      setGetcity([]);
    }
  }, [selectedstateone, countrydata]);

  const validationSchema = Yup.object({
    category: Yup.string().required("category is required*"),
    subCategoryid: Yup.string().required("subCategory is required*"),
    country: Yup.string().required("country is required*"),
    state: Yup.string().required("state is required*"),
    city: Yup.string().required("city is required*"),
    price: Yup.string().required("price is required*"),
    currency: Yup.string().required("currency is required*"),
    area: Yup.string().required("area is required*"),
    contactnumber: Yup.string().required("contactnumber is required*"),
    description: Yup.string().required("description is required*"),
    email: Yup.string()
      .required("Email is required*")
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        "Please enter a valid email address"
      ),
  });
  return (
    <div className="property-ad-form">
      <Row className="property-ad-form-row">
        <div className="property-ad-form-page screenHeight d-flex justify-content-center align-items-center">
          <Col
            lg={9}
            md={11}
            sm={12}
            xs={12}
            className="property-ad-form-card Form-Shadow pb-3 col-lg-10 col-md-12 col-sm-12"
          >
            {location.pathname === `/update-business-Ad/${itemid}` ? (
              <div className="arrowback ps-3">
                <BackArrow back="/SellingSide" black="black" />
              </div>
            ) : (
              <div className="arrowback ps-3">
                <BackArrow
                  back={back || `/personal-add/${itemid}`}
                  black="black"
                  mystyle="p-1 ps-3"
                />
              </div>
            )}
            <div className="p-3">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  category: propertyadd?.category || "",
                  subCategoryid: propertyadd?.subCategoryid || "",
                  country: selectedCountry || propertyadd?.country || "",
                  state: selectedstateone || propertyadd?.state || "",
                  city: selectedcity || propertyadd?.city || "",
                  price: propertyadd?.price || "",
                  currency: propertyadd?.currency || "",
                  area: propertyadd?.area || "",
                  description: propertyadd?.description || "",
                  contactnumber: propertyadd?.contactnumber || "",
                  email: propertyadd?.email || "",
                  saletype: propertyadd?.saletype || "",
                }}
                validateOnBlur={false}
                validationSchema={validationSchema}
                onSubmit={(values) => {}}
              >
                {({
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  values,
                  errors,
                  touched,
                  isValid,
                  dirty,
                }) => (
                  <Form
                    autoComplete="off" // Disable autofill for the form
                    onSubmit={(e) => {
                      handleSubmit(e);
                    }}
                  >
                    {/* Hidden input to trick autofill */}
                    <input
                      type="text"
                      style={{ display: "none" }}
                      
                    />
                    <Row className="property-ad-form-fields">
                      <Col className="ps-4" md={3} lg={3} xl={3}>
                        <Form.Label className="custm-lble">Select Category</Form.Label>
                        <Form.Select
                          className="form-select-seller"
                          aria-label="Default select example"
                          name="category"
                          value={values.category || propertyadd?.category || ""}
                          onChange={(e) => {
                            Handledata(e);
                            handleChange(e);
                            setFieldValue("category", e.target.value);
                          }}
                          onClick={Firstcategory}
                          onBlur={handleBlur}
                        >
                          <option value="">Select-Category</option>
                          {shopCategory?.map((category) => (
                            <option
                              key={category._id}
                              value={`${category?._id}.${category?.name}`}
                            >
                              {category?.name}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.category && touched.category ? (
                          <div>
                            <p className="error_text_color">{errors.category}</p>
                          </div>
                        ) : null}
                      </Col>

                      <Col className="ps-4" md={3} lg={3} xl={3}>
                        <Form.Label className="custm-lble">Select Sub-Category</Form.Label>
                        <Form.Select
                          className="form-select-seller"
                          aria-label="Default select example"
                          name="subCategoryid"
                          value={values.subCategoryid || propertyadd?.subCategory || ""}
                          onChange={(e) => {
                            Handledata(e);
                            handleChange(e);
                            setFieldValue("subCategoryid", e.target.value);
                          }}
                          onClick={Mydata}
                          onBlur={handleBlur}
                          autoComplete="off"
                        >
                          <option value="">Select Sub-Category</option>
                          {shopCategorytwo?.map((category) => (
                            <option
                              key={category._id}
                              value={`${category?._id}.${category?.name}`}
                            >
                              {category?.name}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.subCategoryid && touched.subCategoryid ? (
                          <div>
                            <p className="error_text_color">{errors.subCategoryid}</p>
                          </div>
                        ) : null}
                      </Col>

                      <Col className="ps-4" md={3} lg={3} xl={3}>
                        <Form.Label className="custm-lble">Country*</Form.Label>
                        <Form.Select
                          aria-label="Select Country"
                          name="country"
                          className="form-select-seller"
                          value={selectedCountry || values.country || ""}
                          onChange={(e) => {
                            const val = e.target.value;
                            setSelectedCountry(val);
                            setSelectedstateone("");
                            setSelectedcity("");
                            setPropertyadd((prevState) => ({
                              ...prevState,
                              country: val,
                              state: "",
                              city: "",
                            }));
                            handleChange(e);
                            setFieldValue("country", val);
                            setFieldValue("state", "");
                            setFieldValue("city", "");
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                        >
                          <option value="">Select-Country</option>
                          {country.map((item) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.country && touched.country ? (
                          <div>
                            <p className="error_text_color">{errors.country}</p>
                          </div>
                        ) : null}
                      </Col>

                      <Col className="ps-4" md={3} lg={3} xl={3}>
                        <Form.Label className="custm-lble">State*</Form.Label>
                        <Form.Select
                          aria-label="Select State"
                          name="state"
                          className="form-select-seller"
                          value={selectedstateone || values.state || ""}
                          onChange={(e) => {
                            const val = e.target.value;
                            setSelectedstateone(val);
                            setSelectedcity("");
                            setPropertyadd((prevState) => ({
                              ...prevState,
                              state: val,
                              city: "",
                            }));
                            handleChange(e);
                            setFieldValue("state", val);
                            setFieldValue("city", "");
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                        >
                          <option value="">Select-State</option>
                          {getState.map((item) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.state && touched.state ? (
                          <div>
                            <p className="error_text_color">{errors.state}</p>
                          </div>
                        ) : null}
                      </Col>

                      <Col className="ps-4 mt-3" md={3} lg={3} xl={3}>
                        <Form.Label className="custm-lble">City*</Form.Label>
                        <Form.Select
                          aria-label="Select City"
                          name="city"
                          className="form-select-seller"
                          value={selectedcity || values.city || ""}
                          onChange={(e) => {
                            const val = e.target.value;
                            setSelectedcity(val);
                            setPropertyadd((prevState) => ({
                              ...prevState,
                              city: val,
                            }));
                            handleChange(e);
                            setFieldValue("city", val);
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                        >
                          <option value="">Select-City</option>
                          {getcity.map((item) => (
                            <option key={item.name} value={item.name}>
                              {item.name}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.city && touched.city ? (
                          <div>
                            <p className="error_text_color">{errors.city}</p>
                          </div>
                        ) : null}
                      </Col>

                      <Col className="ps-4 mt-3" md={3} lg={3} xl={3}>
                        <Form.Label className="custm-lble">Actual Area</Form.Label>
                        <Form.Control
                          placeholder="Actual Area"
                          name="area"
                          className="input-style form-control-seller"
                          defaultValue={propertyadd?.area}
                          onChange={(e) => {
                            handleValue(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                        />
                        {errors.area && touched.area ? (
                          <div>
                            <p className="error_text_color">{errors.area}</p>
                          </div>
                        ) : null}
                      </Col>

                      <Col className="ps-4 mt-3" md={3} lg={3} xl={3}>
                        <Form.Label className="custm-lble">Email</Form.Label>
                        <Form.Control
                          placeholder="Email"
                          name="email"
                          className="input-style form-control-seller"
                          defaultValue={propertyadd?.email}
                          onChange={(e) => {
                            handleValue(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                        />
                        {errors.email && touched.email ? (
                          <div>
                            <p className="error_text_color">{errors.email}</p>
                          </div>
                        ) : null}
                      </Col>

                      <Col className="ps-4 mt-3" md={3} lg={3} xl={3}>
                        <Form.Label className="custm-lble">Select Currency</Form.Label>
                        <Form.Select
                          className="form-select-seller"
                          aria-label="Default select example"
                          name="currency"
                          defaultValue={propertyadd?.currency}
                          onChange={(e) => {
                            handleValue(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                        >
                          {propertyadd?.currency?.length > 0 ? (
                            <option>{propertyadd?.currency}</option>
                          ) : (
                            <option value="">Select Currency</option>
                          )}
                          {currencies?.map((e) => (
                            <option key={e.id}>
                              {e?.abbreviation}&nbsp;{e?.name}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.currency && touched.currency ? (
                          <div>
                            <p className="error_text_color">{errors.currency}</p>
                          </div>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="property-ad-form-fields mt-3">
                      <Col className="ps-4" md={3} lg={3} xl={3}>
                        <Form.Label className="custm-lble">Price</Form.Label>
                        <Form.Control
                          placeholder="Price"
                          name="price"
                          className="input-style form-control-seller"
                          defaultValue={propertyadd?.price}
                          onChange={(e) => {
                            handleValue(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                        />
                        {errors.price && touched.price ? (
                          <div>
                            <p className="error_text_color">{errors.price}</p>
                          </div>
                        ) : null}
                      </Col>

                      <Col className="ps-4" md={3} lg={3} xl={3}>
                        <Form.Label className="custm-lble">Contact Number</Form.Label>
                        <Form.Control
                          placeholder="number"
                          name="contactnumber"
                          className="input-style form-control-seller"
                          defaultValue={propertyadd?.contactnumber}
                          onChange={(e) => {
                            handleValue(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                        />
                        {errors.contactnumber && touched.contactnumber ? (
                          <div>
                            <p className="error_text_color">{errors.contactnumber}</p>
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                    <Form.Label className="custm-lble pt-4 ps-4">
                      <h6>Sale/Rent/Lease</h6>
                    </Form.Label>
                    <Form className="ps-4">
                      {["radio"].map((type) => (
                        <div key={`inline-${type}`} className="mb-2">
                          <Form.Check
                            inline
                            label="Sale"
                            value="Sale"
                            name="saletype" // Non-standard name
                            type={type}
                            id={`inline-${type}-1`}
                            className="labelText"
                            onChange={(e) => {
                              handleValue(e);
                            }}
                            checked={propertyadd?.saletype === "Sale"}
                            autoComplete="off"
                          />
                          <Form.Check
                            inline
                            label="Rent"
                            value="rent"
                            name="saletype" // Non-standard name
                            type={type}
                            id={`inline-${type}-2`}
                            className="labelText"
                            onChange={(e) => {
                              handleValue(e);
                            }}
                            checked={propertyadd?.saletype === "rent"}
                            autoComplete="off"
                          />
                          <Form.Check
                            inline
                            label="Lease"
                            value="Lease"
                            name="saletype" // Non-standard name
                            type={type}
                            id={`inline-${type}-3`}
                            className="labelText"
                            onChange={(e) => {
                              handleValue(e);
                            }}
                            checked={propertyadd?.saletype === "Lease"}
                            autoComplete="off"
                          />
                        </div>
                      ))}
                    </Form>
                    <div className="ps-2 pe-2">
                      <Form.Label className="custm-lble">Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        name="description" // Non-standard name
                        className="input-style"
                        defaultValue={propertyadd?.description}
                        onChange={(e) => {
                          handleValue(e);
                          handleChange(e);
                        }}
                        
                      />
                      {errors.description && touched.description ? (
                        <div>
                          <p className="error_text_color">{errors.description}</p>
                        </div>
                      ) : null}
                    </div>
                    <div className="d-flex justify-content-between">
                    
                      <Col>
  <Row>
    <Col lg="9" className="me-auto">
      <Row>
        <Col lg={3} className="mt-2 ms-2">
          <Card
            style={{
              width: "6rem",
              height: "6rem",
              position: "relative", // ✅ to position loader
            }}
            {...getRootProps()}
            className="dropzone"
          >
            {/* Show loader if uploading */}
            {isUploading ? (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(255,255,255,0.7)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  borderRadius: "0.5rem",
                }}
              >
                <div
                  className="spinner-border text-primary"
                  style={{ width: "1.5rem", height: "1.5rem" }}
                  role="status"
                ></div>
                <small className="mt-1">{uploadProgress}%</small>
              </div>
            ) : (
              <>
                <Card.Img className="imet-fit" src={images.AddImage} />
                <Card.Body>
                  <input
                    type="file"
                    id="file"
                    style={{ display: "none" }}
                    {...getInputProps()}
                    multiple
                    autoComplete="off"
                  />
                </Card.Body>
              </>
            )}
          </Card>
        </Col>

        {displayimg?.length > 0 && (
          <Col
            lg={7}
            className="property-ad-form-image-list mt-1 d-flex"
          >
            {displayimg.map((image, index) => (
              <Card
                key={index}
                className="me-2 mt-1"
                style={{
                  width: "6rem",
                  height: "6rem",
                  border: "2px solid",
                  position: "relative",
                }}
              >
                <Card.Img
                  className="imet-fit upload-img mt-0"
                  src={getAsset(image)}
                  alt=""
                  crossOrigin="anonymous"
                />
                <div
                  className="close-btnone"
                  onClick={() => removeImage(index)}
                >
                  <ClearIcon />
                </div>
              </Card>
            ))}
          </Col>
        )}
      </Row>
    </Col>
  </Row>
</Col>

                      <div className="d-flex align-items-end pb-3 pe-3">
                        <div className="btns">
                          <button
                            type="button"
                            className="btn1"
                            onClick={() => navigate(back || `/Sale-Bussines-Property/${id}`)}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn2 disable-btn"
                            onClick={butn === "Post" ? handlerFunction : Updatehandler}
                            disabled={
                              location.pathname === `${link}${index}`
                                ? ""
                                : !(isValid && dirty)
                            }
                            data-title={
                              location.pathname === `${link}${index}`
                                ? null
                                : !(isValid && dirty)
                                  ? "Please fill out all Fields to enable button!"
                                  : null
                            }
                          >
                            {butn}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Col>
        </div>
      </Row>
    </div>
  );
};

export default PropertyAdForm;